import React, { 
    useState ,
} from "react"

import { 
    Search, 
} from "react-bootstrap-icons"

import { 
    ListGroup,
} from "react-bootstrap"

import "../../Stylesheets/Header.css"
import "./style.css"
import EMETLSegmentedControl from "../../../View/Components/EMETLSegmentedControl"

const NAME_MAP = {
    "Tasks": ["TaskNumbers"],
    "Assessor": ["AssessorName", "AssessorEmail"],
}

/**
 * Get all objects which match the name search string
 *
 * @param {string} needle - The string to search for
 * @param {object[]} haystack - the array of objects to search through
 * @param {string} attribute - The object member to filter search results by
 * @returns {object[]} All objects whose attribute matches the search string
 */

export const getMatchingValues = (needle: string, haystack: object[], attribute: string): object[] =>
{
    const matches = []
    if(needle === "")
        return matches

    console.log(attribute)
    const allAttributes = NAME_MAP[attribute] || [attribute]
    allAttributes.forEach((a: string) => {
        for(const straw of haystack)
        {   
            if(straw[a]?.toLowerCase().includes(needle.toLowerCase()))
            {
                matches.push(straw)
            }
        }
    })
        
    return matches
}

export type SearchBarProps = {
    haystack?: object[],
    name: string,
    placeholder: string,
    attribute: string,
    options: string[],
    select: (element: object) => void,
    handleSearch?: (value: string, attr: string, setMatches: (m: string[]) => void) => void,
}

const SearchBar = (props: SearchBarProps) => {
    const [matches, setMatches] = useState([])
    const handleInputChange = (value: string, attr: string) => {
        setNeedle(value)
        setMatches(getMatchingValues(value, haystack, attr))
    }

    const {
        haystack = [],
        name,
        placeholder,
        attribute,
        options,
        select,
        handleSearch = handleInputChange,
    } = props

    const [attr, setAttr] = useState(attribute)
    const [needle, setNeedle] = useState("")
    const [selectedTab, setSelectedTab] = useState(null)

    const searchList = []
    let key = 0
    const handleAttributeChange = (index: number) => {
        setSelectedTab(index)
        setAttr(options[index])
        handleInputChange(needle, options[index])
    }

    for(const match of matches) {
        searchList.push(
            <ListGroup.Item
                key={key}
                action
                onClick={()=>{select( match )}}
            >
                {match[ name ]}
            </ListGroup.Item>
        )
        key++
    }

    return(
        <div id="searchArea" >
            <Search id="searchGlass"/>
            <input id="searchBar" 
                className="form-control" 
                type="text" 
                placeholder={placeholder} 
                aria-label="Search"
                onChange={e => {handleSearch(e.target.value, attr, setMatches)} }
            />
            <ListGroup id="searchResults">
                {matches && matches.map(
                    ( match, index ) => {
                        return (
                            <ListGroup.Item
                                key={index}
                                action
                                onClick={()=>{
                                    setMatches([])
                                    setNeedle("")
                                    select( match )}
                                }
                                style={{ zIndex:10000, position: "relative" }}
                            >
                                {match[name]}
                            </ListGroup.Item>
                        )
                    }
                )}
            </ListGroup>
            {options && options?.length > 1 && (
                <EMETLSegmentedControl 
                    options={options} 
                    perform={index => {handleAttributeChange(index)}}
                    selectedTab={selectedTab} 
                />
            )}
        </div>
    )
}

export default SearchBar